import styled from "styled-components"
export const CharGroup = styled.svg``
